<template>
  <div class="report_box">
    <Header pageTitle="万商数据" />
    <van-tabs v-model="active" sticky @click="onClick">
      <van-tab name="1" title="行业报告"></van-tab>
      <van-tab name="2" title="发布机构"></van-tab>
    </van-tabs>
    <ReportDropdown
      v-if="active === '1'"
      :dropdownValue="industryLevelOne.queryValue"
      :dropdownOption="dropdownoption"
      @getDropdownValue="getDropdownValue"
      :dropdownValue1="productionOrg.queryValue[0]"
      :dropdownOption1="dropdownoption1"
      @getDropdownValue1="getDropdownValue1"
    />
    <van-list
      v-if="active === '1'"
      class="bg-list"
      v-model="loading"
      :finished="finished"
      :error="error"
      :offset="0"
      :finished-text="articleList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="list-box" v-if="loading || articleList.length > 0">
        <BgItem
          class="bg-item"
          v-for="item in articleList"
          :key="item.id"
          :title="item.title"
          :cover="item.albumPics"
          :price="item.goodsPrice"
          :industryOne="item.industryLevelOneVal"
          :industryTwo="item.industryLevelTwoVal"
          @click.native="toDetail(item.id)"
        />
      </div>
      <noneList noneType="bgList" v-else />
    </van-list>
    <van-list
      v-if="active === '2'"
      class="bg-list"
      v-model="institutionLoading"
      :finished="institutionFinished"
      :error="institutionError"
      :offset="0"
      :finished-text="dataList.length > 0 ? '加载完毕' : ''"
      error-text="请求失败，点击重新加载"
      @load="onLoadInstitution"
    >
      <div class="list-box" v-if="institutionLoading || dataList.length > 0">
        <JgItem
          class="jg-item"
          v-for="(item, index) in dataList"
          :key="index"
          :item="item"
        />
      </div>
      <noneList noneType="bgList" v-else />
    </van-list>
  </div>
</template>

<script>
import Header from "@/views/mobileView/components/header";
import ReportDropdown from "@/views/mobileView/components/header/reportDropdown";
import noneList from "@/views/mobileView/components/noneList.vue";
import BgItem from "@/views/mobileView/components/listItem/bgItem.vue";
import JgItem from "@/views/mobileView/components/listItem/jgItem.vue";
export default {
  name: "IndustryReport",
  components: {
    Header,
    ReportDropdown,
    noneList,
    BgItem,
    JgItem,
  },
  data() {
    return {
      industryLevelOne: {
        esField: "industryLevelOne",
        queryValue: "0",
      },
      dropdownoption: [{ text: "全部", value: "0" }],
      productionOrg: {
        esField: "productionOrg",
        queryValue: ["0"],
      },
      dropdownoption1: [{ text: "全部", value: "0" }],
      total: 0,
      params: {
        pageNo: 0,
        pageSize: 20,
        beginDateTime: "",
        queryParam: {
          configMap: {
            must: [
              {
                esField: "goodsTypeId",
                queryValue: "4",
              },
            ],
          },
        },
      },
      institutionTotal: 0,
      institutionParams: {
        pageNo: 0,
        pageSize: 20,
        beginDateTime: "",
      },
      institutionLoading: false,
      institutionFinished: false,
      institutionError: false,
      articleList: [],
      loading: false,
      finished: false,
      error: false,
      active: "1",
      dataList: [],
    };
  },
  created() {
    this.getDropdownOption();
    this.getDropdownOption1();
  },
  methods: {
    // 触底加载
    onLoad() {
      this.params.pageNo += 1;
      this.getList();
    },
    // 获取行业分类筛选列表
    async getDropdownOption() {
      const res = await this.$apis.goodsServe.getReportClassifyOneList();
      let optionsArr = res.content.indOneList.map((item) => {
        return {
          text: item.name,
          value: item.id,
        };
      });
      this.dropdownoption.push(...optionsArr);
    },
    // 获取出品机构筛选列表
    async getDropdownOption1() {
      const res = await this.$apis.goodsServe.getProductionOrgAll();
      res.data = res.data.filter((item) => item);
      let optionsArr = res.data.map((item) => {
        return {
          text: item,
          value: item,
        };
      });
      this.dropdownoption1.push(...optionsArr);
    },
    // 行业分类筛选
    getDropdownValue(value) {
      this.industryLevelOne.queryValue = value;
      this.params.pageNo = 1;
      this.articleList = [];
      this.getList();
    },
    // 出品机构筛选
    getDropdownValue1(value) {
      console.log(value, "value");

      this.productionOrg.queryValue[0] = value;
      this.params.pageNo = 1;
      this.articleList = [];
      this.getList();
    },
    // 获取列表
    async getList() {
      this.loading = true;
      if (this.params.pageNo == 1) {
        this.params.beginDateTime = this.$global.transferDate(new Date());
      }
      let params = this.$global.deepClone(this.params);
      if (this.industryLevelOne.queryValue != "0") {
        params.queryParam.configMap.must.push(this.industryLevelOne);
      }
      if (this.productionOrg.queryValue[0] != "0") {
        params.queryParam.configMap.must.push(this.productionOrg);
      }
      const resp = await this.$apis.searchServe.getEsTsBgList(params);
      if (resp.resultCode == 200) {
        this.finished = resp.data.list.length < 20;
        this.articleList.push(...resp.data.list);
        this.total = +resp.data.total;
      } else {
        this.error = true;
      }
      this.loading = false;
    },
    // 点击进入详情页
    toDetail(id) {
      this.$router.push("/detail/report?id=" + id);
    },
    // 点击tab页
    onClick(name) {
      if (name === "1") {
        this.industryLevelOne.queryValue = "0";
        this.productionOrg.queryValue = ["0"];
        this.params.pageNo = 1;
        this.articleList = [];
        this.getList();
      }
      if (name === "2") {
        this.institutionParams.pageNo = 1;
        this.dataList = [];
        this.getInstitutionList();
      }
    },
    // 获取发布机构列表
    async getInstitutionList() {
      this.institutionLoading = true;
      if (this.institutionParams.pageNo == 1) {
        this.institutionParams.beginDateTime = this.$global.transferDate(
          new Date()
        );
      }
      const res = await this.$apis.listServe.selectReport(
        this.institutionParams
      );
      if (res.resultCode == 200) {
        this.institutionFinished = res.data.list.length < 20;
        this.dataList.push(...res.data.list);
        this.institutionTotal = +res.data.total;
      } else {
        this.institutionError = true;
      }
      this.institutionLoading = false;
    },
    // 触底加载
    onLoadInstitution() {
      this.institutionParams.pageNo += 1;
      this.getInstitutionList();
    },
  },
};
</script>

<style lang="scss" scoped>
.report_box {
  padding-top: 44px;
  min-height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
  ::v-deep .van-tab {
    color: #333333;
    font-size: 15px;
    line-height: 21px;
  }
  ::v-deep .van-tab--active {
    font-weight: 600;
    font-size: 16px;
    color: #4a79f1;
    line-height: 22.5px;
  }
  ::v-deep .van-tabs__line {
    background-color: #4a79f1;
    height: 2px;
    border-radius: 2px;
    width: 20px;
  }
  .bg-list {
    padding: 12px 12px 0;

    .list-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .bg-item {
        width: 170px;
        margin-bottom: 12px;
      }
      .jg-item {
        width: 100%;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
